import React from 'react';
import { cn } from '@/lib/utils';
import octovetoLogo from '@/assets/octoveto-logo.webp';

interface OctovetoLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const OctovetoLogo: React.FC<OctovetoLogoProps> = ({ 
  size = 'md',
  className 
}) => {
  const sizeClasses = {
    sm: 'h-9 sm:h-10',
    md: 'h-10 sm:h-12',
    lg: 'h-12 sm:h-14'
  };

  return (
    <img 
      src={octovetoLogo} 
      alt="Logo Octoveto" 
      className={cn(
        sizeClasses[size],
        'w-auto object-contain',
        className
      )}
    />
  );
};

export default OctovetoLogo;
